import React, { useState } from 'react';
import { Card, Row, Col } from "react-bootstrap"
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import { useTranslation } from 'react-i18next';
import HEADER_TOOLBAR from '../HEADER_TOOLBAR';
import NoDataLayer from '../../../../../Common/NoDataLayer';
import { ActionButton } from '@fluentui/react';
import { useGetUserPropsKpi } from '../../../../../../hooks/services/sPrivilege/useOfPrivilege';
import { useSelector } from 'react-redux';
import { enum__BOARD_TEMPLATE_TYPE } from '../../../../../../common/Dictionaries';

const CONTRACT_SERVICES = (props) => {
const { t } = useTranslation();
const { 
	inputParam_HideHeader = false,
	inputParam_BoardStructure = null,
    inputParam_Container = null,
	inputParam_ComponentContent = null,
    inputParam_UseFake = false,
	inputParam_ElementId = null
} = props;

const [party, setParty] = useState({items:[
	{
		partidaEstadoAbierta: false,
		partidaMcPasada: '--',
		partidaMesPrevio: '2024/01',
		nPartidas: '--',
	}
]});

const circleStyle = {
	width: "46px",
	height: "46px",
	backgroundColor: "grey",
	borderRadius: '50%',
	padding: '10px',
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
};

const { token: currentAuth } = useSelector((state) => state.auth);
const BoardTypeId = enum__BOARD_TEMPLATE_TYPE.EDP;
const [userPropsKpi, setUserPropsKpi] = useState({hasAccess : null, onlyObserver: null})
useGetUserPropsKpi(BoardTypeId, null, inputParam_ElementId, currentAuth.token.userName, userPropsKpi, setUserPropsKpi)

const handleOnGoToContractParties = () => {
	window.location.href = `/ContactParties/${inputParam_ElementId}`
}

const renderContent = (_data) => {
	return  <Row className='py-0 h-100' style={{opacity: inputParam_UseFake ? ".4" : ""}}>
				{
					(_data !== null && (_data.items && _data.items.length > 0)) &&
					<Col>
						<Row className='border m-1 h-25'>
							<Col>
								<Row>
									<Col className='my-auto font-weight-bold' style={{fontSize: '18px'}}>{_data.items[0].partidaEstadoAbierta === true ? t('data-lang-lbl-openparties') : t('data-lang-lbl-closedparties')}</Col>
								</Row>
								<Row className='pb-1' style={{backgroundColor: "#efefef"}}>
									<Col className='my-auto'>{t('data-lang-lbl-itemstatus')}</Col>
								</Row>
							</Col>
						</Row>
						<Row className='py-1 h-25'>
							<Col className='col-auto my-auto'>
								<div style={circleStyle}>
									<div style={{ fontWeight: "bold", color: "white" }}>P</div>
								</div>
							</Col>
							<Col className='my-auto'>{_data.items[0].nPartidas}</Col>
						</Row>
						<Row className='py-1 h-25'>
							<Col className='col-auto my-auto'>
								<div style={circleStyle}>
									<div style={{ fontWeight: "bold", color: "white" }}>MC</div>
								</div>
							</Col>
							<Col className='my-auto'>{_data.items[0].partidaMcPasada > 0 ? `${t('data-lang-lbl-withcontractmod')} (${_data.items[0].partidaMcPasada})` : t('data-lang-lbl-nocontractmod')}</Col>
						</Row>
						<Row className='py-1 h-25'>
							<Col className='col-auto my-auto'>
								<div style={circleStyle}>
									<div style={{ fontWeight: "bold", color: "white" }}>MP</div>
								</div>
							</Col>
							<Col className='my-auto'>
								{
									_data.items[0].partidaMesPrevio === "0000/00" ?
										t('data-lang-lbl-withoutpreviousmonth') :
										_data.items[0].partidaMesPrevio
								}
							</Col>
						</Row>
					</Col>
				}
				{
					(_data === null || (!_data.items || _data.items.length === 0)) &&
					<NoDataLayer display={true} />
				}
			</Row>
}

return (
	<>
	{
		!inputParam_UseFake &&
		<Card className='board-element-form h-100'>
			{
				!inputParam_HideHeader &&
				<Card.Header className="card-header-compact">
					<Card.Title className="d-flex justify-content-between">
						<b>{ (inputParam_ComponentContent !== null && inputParam_ComponentContent.boardComponentTitle) ?? t('data-lang-boxname-parties')}</b>
						<div className='toolbar d-flex'>
							<HEADER_TOOLBAR inputParam_BoardStructure={inputParam_BoardStructure} inputParam_Container={inputParam_Container} />
						</div>
						{
							(!userPropsKpi.onlyObserver) &&
							<ActionButton text={t('data-lang-lbl-configureitems')} onClick={handleOnGoToContractParties} iconProps={{iconName: "ConfigurationSolid"}} styles={{ icon: { fontSize: 20 } }} />
						}
					</Card.Title>
				</Card.Header>
			}
			<Card.Body className='px-2 pt-0'>
				{renderContent(inputParam_ComponentContent)}
			</Card.Body>
		</Card>
	}
	{
		inputParam_UseFake && renderContent(party)
	}
	</>
)};

export default CONTRACT_SERVICES;